import { IconInfoCircle } from '@tabler/icons-react';
import { Card } from '@zorro/design-system/v2/Card';
import { Box, Group, Icon, Text } from '@zorro/web/design-system';

export const SelfPayNotice = () => {
  return (
    <Card variant="grey" px="md" py="lg">
      <Group gap="xs" wrap="nowrap" align="flex-start">
        <Box>
          <Icon icon={IconInfoCircle} />
        </Box>
        <Text>
          Use this for external plans like Medicare or student plans that can’t
          be paid for with Zorro Pay
        </Text>
      </Group>
    </Card>
  );
};
